export const loginUser = (state, {usuario, token}) => {
    if (token) {
        localStorage.setItem('token', token);
        state.token = token;
    }
    localStorage.setItem('user', JSON.stringify(usuario))
    state.usuario = usuario;
    state.status = 'authenticated';
}

export const logout = (state) => {
    state.usuario = null;
    state.token = null;
    state.status = 'not-authenticated';
    localStorage.removeItem('token');
    localStorage.removeItem('user');
}
